export class AgreementLimitFieldChange {
  fieldLabel: string;

  oldValue: string;

  newValue: string;

  constructor(obj: any = {}) {
    this.fieldLabel = obj.fieldLabel;
    this.oldValue = obj.oldValue;
    this.newValue = obj.newValue;
  }

  public static of(apiObj: any): AgreementLimitFieldChange {
    const obj = apiObj || {};
    return new AgreementLimitFieldChange({
      fieldLabel: obj.fieldLabel,
      oldValue: obj.oldValue,
      newValue: obj.newValue,
    });
  }

  public static ofList(list: any[]): AgreementLimitFieldChange[] {
    return (list || []).map(AgreementLimitFieldChange.of);
  }
}

export default class AgreementLimitHistoryEntry {
  changedByName: string;

  changedAt: string;

  agreementType: string;

  leader: boolean | null;

  changes: AgreementLimitFieldChange[];

  constructor(obj: any = {}) {
    this.changedByName = obj.changedByName;
    this.changedAt = obj.changedAt;
    this.agreementType = obj.agreementType;
    this.leader = obj.leader === undefined ? null : obj.leader;
    this.changes = obj.changes || [];
  }

  public static of(apiObj: any): AgreementLimitHistoryEntry {
    const obj = apiObj || {};
    return new AgreementLimitHistoryEntry({
      changedByName: obj.changedByName,
      changedAt: obj.changedAt,
      agreementType: obj.agreementType,
      leader: obj.leader,
      changes: AgreementLimitFieldChange.ofList(obj.changes),
    });
  }

  public static ofList(list: any[]): AgreementLimitHistoryEntry[] {
    return (list || []).map(AgreementLimitHistoryEntry.of);
  }
}
